import Vue from 'vue'

// Vue app
import App from '@/App.vue'
import router from '@/router/'
import i18n from '@/plugins/i18n'
import store from '@/store/'
import Drawer from '@/components/parts/Drawer'
import Modal from '@/components/parts/Modal'

// Veevalidate validation framework
import './plugins/vee-validate'
import roleAndAccess from './plugins/roleAndAccess'

// global custom plugins
import '@/plugins/'

// global custom directives
import { FailedMedia, ClickOutside } from '@/directives'

// global custom mixins
import { CancelRequests } from '@/mixins'

Vue.use(roleAndAccess, { store })

// create url signatures AWS
Vue.mixin({
  methods: {
    /**
     * @param {String} url - S3 full URL
     * @param {String} type - generator || query
     * @param {Number} mode - generator: 0(public) || 1(private), query: 1 || 2 || 3
     */
    signature: function (url, type, mode) {
      if (!url || !type || !(mode >= 0)) return ''

      const regex = /(cdnpl.me|productlead.me)/gi

      if (!url.match(regex) || url.match(/^(blob:)/)) return url

      const policy = this.$store.getters['user/policy']

      if (this._.get(policy[type], mode)) {
        const aws = policy[type][mode]
        return url + '?Signature=' + aws.signature + '&Policy=' + aws.policy + '&Key-Pair-Id=' + policy.key
      } else {
        return ''
      }
    },
  },
})

// init custom vue mixins
Vue.mixin(CancelRequests)

// init custom vue directives
Vue.use(FailedMedia)
Vue.use(ClickOutside)

// Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = false
// Suppress all Vue logs and warnings.
// Vue.config.silent = true

// global <style> component
Vue.component('VStyle', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  },
})

Vue.prototype.$log = function () {
  let i
  for (i in arguments) {
    window.console.log(arguments[i])
  }
}

Vue.use(Drawer)
Vue.use(Modal)

// init Vue
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// front end testing
// if (window.Cypress) {
//   window.store = store
// }
